import { useState, useEffect } from 'react'
import _ from 'lodash'
import { useSelector, useStore } from 'react-redux'
import {
    Box, Button, Chip, IconButton, Paper, Stack, Tooltip, Typography, alpha
} from '@mui/material'
import RestoreIcon from '@mui/icons-material/Restore'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

import { newGetList, newPost, newPut } from '../../../helper/baseFetch_v2'
import { getString } from '../../../helper/util'
import SharedDialog from '../../../Component/common/dialog/SharedDialog'
import { GlobalDialog } from '../../../Component/GlobalDialog'
import { ListFilter } from '../../../Component/ListDisplay/ListFilter'
import { useListParam } from '../../../hooks/useListParam'
import MUITable from '../../../Component/common/table/MUITable'
import { constants } from '../../../Constants/constants'
import { chipRender } from '../constants'

const resource = 'appVersionHistoryPage'

const listFilters = [
    // {
    //     className: 'filter-input',
    //     label: { resource, key: 'restUrlId' },
    //     clear: true,
    //     value: '',
    //     name: 'restUrlId',
    //     size: constants.SIZE.SMALL,
    // },
]

export default function AppVersionHistoryList({ restUrlId }) {
    const store = useStore()
    const lang = useSelector((state) => state.lang.ui.lang)
    const theme = useSelector((state) => state.theme.ui.theme)

    const [list, setList] = useState([])
    const [listLength, setListLength] = useState(0)
    const [listPagination, setListPagination] = useState({ page: 0, pageSize: 10 })
    const [revertDialog, setRevertDialog] = useState({ open: false, item: null })
    const [dialog, setDialog] = useState({ open: false, dialogActions: [] })

    const { param, onChangeListFilters, onChangeListPage: onChangeListPageParam, onChangeListRowsPerPage: onChangeListRowsPerPageParam } = useListParam({
        initialPath: '',
        initialListFilters: _.cloneDeep(listFilters),
        listTitles: [],
        initialSort: 'createDateTime',
        initialDirection: 'DESC',
        initialPage: 0,
        initialRowsPerPage: 10,
        changeUrlQueryString: false,
    })

    useEffect(() => {
        fetchList()
    }, [listPagination.page, listPagination.pageSize])

    function fetchList() {
        const filter = {}
        param.listFilters.forEach((f) => {
        if (f.value !== '' && f.value !== undefined) filter[f.name] = f.value
        })
        newGetList({
        path: 'gulu-console/merchant/shop-app-version-control/history',
        queryObj: {
            ...filter,
            ...(restUrlId ? { restUrlId } : {}),
            pageSize: listPagination.pageSize,
            page: listPagination.page,
            sortingList: [{ sort: 'createDateTime', direction: 'DESC' }],
        },
        successCallback: (payload) => {
            setList(payload?.list ?? [])
            setListLength(payload?.total ?? 0)
        },
        store,
        })
    }

    function onChangeListPage(e, newPage) {
        setListPagination((prev) => ({ ...prev, page: newPage }))
        onChangeListPageParam(newPage)
    }

    function onChangeListRowsPerPage(e) {
        const rowsPerPage = e?.target?.value
        setListPagination((prev) => ({ ...prev, pageSize: rowsPerPage }))
        onChangeListRowsPerPageParam(rowsPerPage)
    }

    function onClickRevert(item) {
        setRevertDialog({ open: true, item })
    }

    function onConfirmRevert() {
        const { item } = revertDialog
        newPut({
        path: `gulu-console/merchant/shop-app-version-control/history/${item.id}/revert`,
        body: {},
        successCallback: () => {
            setRevertDialog({ open: false, item: null })
            setDialog({
            open: true,
            dialogContentText: { key: 'revertSuccess' },
            dialogActions: [
                {
                label: { key: 'backList' },
                onClick: () => {
                    setDialog({ open: false, dialogActions: [] })
                    fetchList()
                },
                },
            ],
            })
        },
        store,
        })
    }

    const columns = [
        {
        field: 'createDateTime',
        headerName: 'Date',
        flex: 1,
        renderCell: (params) =>
            params.row.createDateTime
            ? new Date(params.row.createDateTime).toLocaleString()
            : '-',
        },
        {
        field: 'restUrlIdList',
        headerName: 'Restaurants',
        flex: 1,
        renderCell: (params) => (
            <Stack direction="row" spacing={0.5} flexWrap="wrap">
            {(params.row.restUrlIdList ?? []).map((id) => (
                <Chip key={id} label={id} size="small" variant="outlined" />
            ))}
            </Stack>
        ),
        },
        {
        field: 'actions',
        headerName: 'Actions',
        flex: 1,
        width: 80,
        renderCell: (params) => (
            <Tooltip title="Revert">
            <IconButton size="small" color="warning" onClick={() => onClickRevert(params.row)}>
                <RestoreIcon fontSize="small" />
            </IconButton>
            </Tooltip>
        ),
        },
    ]

    return (
        <Box sx={{ p: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
            <Typography variant="h5" fontWeight={600}>
            {getString(lang, resource, 'mainTitle', theme)}
            </Typography>
        </Stack>

        <ListFilter onChangeListFilters={onChangeListFilters} listFilters={param.listFilters} />

        <Box sx={{ flex: 1, overflow: 'auto' }}>
            <MUITable
            stickyHeader
            columns={columns}
            rows={list}
            pagination={listPagination}
            setPagination={setListPagination}
            listLength={listLength}
            handleChangePage={onChangeListPage}
            handleChangeRowsPerPage={onChangeListRowsPerPage}
            stickyEditBtn
            />
        </Box>

        {/* ── Revert Confirm Dialog ── */}
        <SharedDialog
            maxWidth="xl"
            open={revertDialog.open}
            onClose={() => setRevertDialog({ open: false, item: null })}
            title="Revert Version"
            content={revertDialog.item && <RevertDiffView item={revertDialog.item} />}
            actions={
            <Stack direction="row" gap={1}>
                {/* <Button variant="outlined" onClick={() => setRevertDialog({ open: false, item: null })}>
                Cancel
                </Button> */}
                <Button variant="contained" startIcon={<RestoreIcon />} onClick={onConfirmRevert}>
                Confirm Revert
                </Button>
            </Stack>
            }
        />

        {dialog?.open && <GlobalDialog dialogInfo={dialog} />}
        </Box>
    )
}

// ── Left / Right diff tables ─────────────────────────────────────────────────

const ALL_FIELDS = [
  { key: 'restUrlId',    label: 'Restaurant' },
  { key: 'deviceType',   label: 'Device Type' },
  { key: 'buildTarget',  label: 'Build Target' },
  { key: 'appVersion',   label: 'App Version' },
  { key: 'buildNumber',  label: 'Build #' },
  { key: 'customCode',   label: 'Custom Code' },
  { key: 'forceUpdate',  label: 'Force Update' },
  { key: 'fileUrl',      label: 'File URL' },
  { key: 'fileChecksum', label: 'File Checksum' },
  { key: 'status',       label: 'Status' },
]

function formatValue(key, value) {
    if (value === null || value === undefined || value === '')
        return <Typography component="span" variant="body2" color="textSecondary">—</Typography>
    // if (key === 'forceUpdate')
    //     return <Chip label={value ? 'Yes' : 'No'} size="small" color={value ? 'warning' : 'default'} variant="outlined" />
    return String(value)
}

// Build a lookup key for matching entries across snapshots
function entryKey(e) {
    return `${e.restUrlId}||${e.deviceType}||${e.buildTarget}`
}

function SnapshotTable({ highlightDiff = false, entries, otherEntries, label, labelColor }) {
    return (
        <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
            variant="subtitle2"
            fontWeight={700}
            sx={{ mb: 1, px: 1, py: 0.5, borderRadius: 1, bgcolor: labelColor, display: 'inline-block' }}
        >
            {label}
        </Typography>
        {entries.length === 0 ? (
            <Typography variant="body2" color="textSecondary">No entries</Typography>
        ) : (
            <Stack spacing={1.5}>
            {entries.map((entry, i) => {
                const peer = otherEntries.find((e) => entryKey(e) === entryKey(entry))
                return (
                <Paper 
                    key={i} 
                    variant="outlined" 
                    sx={{ 
                        p: 1.5,
                        bgcolor: (theme) => alpha(theme.palette[chipRender(entry?.buildTarget)?.color || 'primary'].main, 0.1),
                    }} >
                    <Stack spacing={0.5}>
                    {ALL_FIELDS.map((f) => {
                        const val     = entry[f.key] ?? null
                        const peerVal = peer?.[f.key] ?? null
                        const isDiff  = highlightDiff && String(val) !== String(peerVal)
                        return (
                        <Box
                            key={f.key}
                            sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            px: 1,
                            py: 0.5,
                            borderRadius: 1,
                            bgcolor: isDiff ? 'success.lighter' : 'transparent',
                            }}
                        >
                            <Typography variant="caption" color="textSecondary" sx={{ minWidth: 110, fontWeight: 600, flexShrink: 0 }}>
                            {f.label}
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: isDiff ? 700 : 400, backgroundColor: isDiff ? '#ffcc00' : 'transparent', px: 1, wordBreak: 'break-all' }}>
                            {formatValue(f.key, val)}
                            </Typography>
                        </Box>
                        )
                    })}
                    </Stack>
                </Paper>
                )
            })}
            </Stack>
        )}
        </Box>
    )
}

function RevertDiffView({ item }) {
    const beforeEntries = item.beforeSnapshot?.entries ?? []
    const afterEntries  = item.afterSnapshot?.entries  ?? []

    return (
        <Stack spacing={1}>
            <Typography variant="body2" color="textSecondary">
                Reverting will restore the <strong>Before</strong> snapshot. Highlighted cells indicate differences.
            </Typography>
            <Stack direction="row" spacing={2} alignItems="flex-start">
                <SnapshotTable
                entries={afterEntries}
                otherEntries={beforeEntries}
                label="After (Current)"
                labelColor="error.lighter"
                />
                <Box 
                    sx={{ display: 'flex', alignItems: 'center', alignSelf: 'center', flexShrink: 0, minWidth: 35 }}
                >
                    <ArrowForwardIcon sx={{ position: 'absolute', top: '50%' }} fontSize="large" color="action" />
                </Box>
                <SnapshotTable
                    highlightDiff
                    entries={beforeEntries}
                    otherEntries={afterEntries}
                    label="Old (Will Revert To)"
                    labelColor="success.lighter"
                />
            </Stack>
        </Stack>
    )
}
